/**
 * mixin
 */

//common
export default {
    data: function() {
      return {
        query_params: null
      }
    },
    mounted: function() {
      console.log('Mixin(common) Component mounted.');

      //get query_params
      this.get_query_params();
    },
    methods: {
      /**
       * query
       */
      get_query_params: function() {
        var uri = new URI(window.location);
        this.query_params = uri.query(true);
      },
      /**
       * scrollto
       * @type {[type]}
       */
      scroll_to: function(dom_selector) {
        $('html, body').animate({scrollTop:$(dom_selector).offset().top},300);
      },
      /**
       * toast
       * @type {[type]}
       */
       make_toast: function(body,color) {
         this.$bvToast.toast(body, {
           title: '中谷財団アーカイブ',
           variant: color,
           autoHideDelay: 5000,
           solid: true,
           appendToast: true
         });
       },
      /**
       * API()
       */
      api:function() {
        return {

          /**
           * [description]
           * @param  {[type]} email           [description]
           * @param  {[type]} [callback=null] [description]
           * @return {[type]}                 [description]
           */
          check_email_available: function(email,callback=null) {
            //ajax
            var params = new URLSearchParams();
                params.append('action', 'check_email_available');
                params.append('email', email);

            axios.post(ajaxurl, params)
            .then(function (response) {
              console.log(response);

              if(callback) {
                callback.call({},response);
              }
            })
            .catch(function (error) {
              console.log(error);

              if(callback) {
                callback.call({},error);
              }
            });
          },
          /**
           * [description]
           * @param  {[type]} param           [description]
           * @param  {[type]} [callback=null] [description]
           * @return {[type]}                 [description]
           */
          get_members_list: function(param,callback=null) {

            //ajax
            var params = new URLSearchParams();
                params.append('action', 'get_members_list');

                //param
                _.forEach(param,function(val,key){
                  params.append(key, val);
                });

            axios.post(ajaxurl, params)
            .then(function (response) {
              console.log(response);

              if(callback) {
                callback.call({},response);
              }
            })
            .catch(function (error) {
              console.log(error);

              if(callback) {
                callback.call({},error);
              }
            });
          },
          /**
           * [description]
           * @param  {[type]} member_id      [description]
           * @param  {[type]} [callback=null] [description]
           * @return {[type]}                 [description]
           */
          approve_member: function(member_id,callback=null) {

            if(!member_id) {
              return false;
            }

            //ajax
            var params = new URLSearchParams();
                params.append('action', 'approve_member');
                params.append('member_id', member_id);

            axios.post(ajaxurl, params)
            .then(function (response) {
              console.log(response);

              if(callback) {
                callback.call({},response);
              }
            })
            .catch(function (error) {
              console.log(error);

              if(callback) {
                callback.call({},error);
              }
            });
          },
          /**
           * [description]
           * @param  {[type]} member_id      [description]
           * @param  {[type]} [callback=null] [description]
           * @return {[type]}                 [description]
           */
          delete_member: function(member_id,callback=null) {

            if(!member_id) {
              return false;
            }

            //ajax
            var params = new URLSearchParams();
                params.append('action', 'delete_member');
                params.append('member_id', member_id);

            axios.post(ajaxurl, params)
            .then(function (response) {
              console.log(response);

              if(callback) {
                callback.call({},response);
              }
            })
            .catch(function (error) {
              console.log(error);

              if(callback) {
                callback.call({},error);
              }
            });
          },
          /**
           * [description]
           * @param  {[type]} member_id      [description]
           * @param  {[type]} [callback=null] [description]
           * @return {[type]}                 [description]
           */
          update_member: function(member_id,param,callback=null) {

            if(!member_id || !param) {
              return false;
            }

            //param
            var params = new URLSearchParams();
                params.append('action', 'update_member');
                params.append('member_id', member_id);

            _.forEach(param,function(val,key){
              params.append(key, val);
            });

            //ajax
            axios.post(ajaxurl, params)
            .then(function (response) {
              console.log(response);

              if(callback) {
                callback.call({},response);
              }
            })
            .catch(function (error) {
              console.log(error);

              if(callback) {
                callback.call({},error);
              }
            });
          }// end update_member
        }// end return
      }// end of api
      /**
       *
       */
    }
};
